export default "__VITE_ASSET__e5d36c7f__"